import { render, staticRenderFns } from "./Portfolio.vue?vue&type=template&id=49622115&"
import script from "./Portfolio.js?vue&type=script&lang=js&"
export * from "./Portfolio.js?vue&type=script&lang=js&"
import style0 from "./Portfolio.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports